import { Home } from 'lucide-react'
import { router } from '@inertiajs/react'
import { useTranslation } from 'react-i18next'

export interface BreadcrumbItem {
  id: string | null
  name: string
  url?: string
}

interface BreadcrumbProps {
  items: BreadcrumbItem[]
  currentItemId?: string | null
}

export default function Breadcrumb({ items, currentItemId }: BreadcrumbProps) {
  const { t } = useTranslation()

  const handleNavigate = (item: BreadcrumbItem) => {
    if (item.url) {
      router.get(item.url)
    }
  }

  const getDisplayName = (item: BreadcrumbItem): string => {
    // If name is 'home', translate it; otherwise use as-is
    return item.name === 'home' ? t('fileExplorer.breadcrumb.home') : item.name
  }

  return (
    <div className="breadcrumbs text-sm">
      <ul>
        {items.map((item, index) => {
          const isHome = item.id === null
          const isCurrent = item.id === currentItemId || (index === items.length - 1 && currentItemId === undefined)

          return (
            <li key={item.id ?? 'home'}>
              <button
                onClick={() => handleNavigate(item)}
                className={`flex items-center gap-1 hover:text-primary transition-colors ${
                  isCurrent ? 'text-primary font-semibold' : ''
                }`}
              >
                {isHome && <Home className="w-4 h-4" />}
                {getDisplayName(item)}
              </button>
            </li>
          )
        })}
      </ul>
    </div>
  )
}
